import * as React from 'react';
import { useActions } from '../ContentPlanning/contentPlanningActions';
import { Navigate } from 'react-router-dom';
import { ContentPlanning } from '../ContentPlanning/contentPlanning';
import { Overlay } from 'rcd-cpp-ui/ui/loader';
import { AppRefId } from '../../utils/constants';
import { useSelector } from '../../utils/useSelector';

export const Home = () => {
  const userSettings = useSelector(s => s.planning?.userSettings);
  const { init } = useActions();
  React.useEffect(() => {
    init(null);
  }, []);
  if (!userSettings) return <Overlay />;
  const userSetting = userSettings[AppRefId];
  const wsId =
    userSetting?.props?.homeWorkspaceId ||
    userSetting?.props?.selectedWorkspaceId;
  if (!wsId) return <ContentPlanning />;
  const selectedViewId = userSetting.props.selectedViewId;
  const params = selectedViewId ? `?v=${selectedViewId}` : '';
  return <Navigate to={`/w/${wsId}${params}`} replace />;
};
